enum PdfStatusEnum {
  UNAVAILABLE = 'UNAVAILABLE',
  DONE = 'DONE',
  IN_PROGRESS = 'IN_PROGRESS',
}

export type PdfStatusString = keyof typeof PdfStatusEnum
export type PdfStatus = PdfStatusEnum | PdfStatusString
export default PdfStatusEnum
